import axios from 'axios';
import React, { useEffect, useState } from 'react'

export default function View({id}) {
    const [data, setdata] = useState([])
    console.log(id)



    useEffect(() => {
        axios.get(`https://rasmasa.com/api/admin/who-are-we/${id}`)
          .then(response => {
            setdata(response?.data?.data);
          console.log(response.data.data , "datadatadata");
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }, []);
  return <>
  
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>الاسم</p>
    <p className='mx-4'>{data?.name}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>الوصف</p>
    <p className='mx-4'>{data?.description}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>الوصف 1</p>
    <p className='mx-4'>{data?.description1}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>رقم 1</p>
    <p className='mx-4'>{data?.number1}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>الوصف 2</p>
    <p className='mx-4'>{data?.description2}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>رقم 2</p>
    <p className='mx-4'>{data?.number2}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>الوصف 3</p>
    <p className='mx-4'>{data?.description3}</p>
  </div>
  <div className="d-flex mx-3 mt-4 mb-4">
    <p className='fw-bold'>رقم 3</p>
    <p className='mx-4'>{data?.number3}</p>
  </div>

  
  </>
}
